export default __webpack_public_path__ + "static/fonts/Brushaff.c2c06e5.woff";